import React from 'react'
import { connect } from 'react-redux'

import CoverGeniusLandingPage from './CoverGenius'
import { isCoverGeniusEnabled } from 'lib/insurance/insuranceHelpers'
import Error404Page from 'components/Pages/Error404Page'

interface Props {
  currentRegionCode: string;
}

function InsuranceLandingPage({ currentRegionCode }: Props) {
  if (isCoverGeniusEnabled(currentRegionCode)) {
    return <CoverGeniusLandingPage />
  }

  return <Error404Page invalidRegion />
}

const mapStateToProps = (state: App.State) => ({
  currentRegionCode: state.geo.currentRegionCode,
})

export default connect(mapStateToProps)(InsuranceLandingPage)
